// extracted by mini-css-extract-plugin
export default {"container":"Header_container__O3R-8","content":"Header_content__e6Qup","heading":"Header_heading__2OLd4","role":"Header_role__UlNV5","tags":"Header_tags__dlJ8U"};